import { useEffect, useState } from "react";
import { ChartWidget } from "../api/types";
import { ChartWidgetRenderer } from "../components/charts/ChartWidgetRenderer";

// Questa pagina la puoi collegare al tuo endpoint "overview" se già lo hai.
// Qui ti lascio struttura: slot grafici generici.

export function VendorOverviewPage() {
  const [widgets, setWidgets] = useState<ChartWidget[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: fetch overview widgets provider
    setWidgets([]);
    setLoading(false);
  }, []);

  return (
    <div className="container py-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="m-0">Overview Provider</h4>
      </div>

      {loading && <div className="alert alert-info">Caricamento…</div>}

      <div className="row g-3">
        {widgets.map((w) => (
          <div className="col-12 col-lg-6" key={w.id}>
            <div className="card shadow-sm">
              <div className="card-header fw-semibold">{w.id}</div>
              <div className="card-body">
                <ChartWidgetRenderer widget={w} mode={w.id.startsWith("state") ? "stacked" : "grouped"} />
              </div>
            </div>
          </div>
        ))}
        {!loading && widgets.length === 0 && (
          <div className="col-12">
            <div className="alert alert-warning">Nessun widget disponibile per questo provider.</div>
          </div>
        )}
      </div>
    </div>
  );
}